// extracted by mini-css-extract-plugin
export var action_btn = "palette_from_image-module--action_btn--ec295";
export var active = "palette_from_image-module--active--35225";
export var color_swatch = "palette_from_image-module--color_swatch--12282";
export var colors_from_image_wrapper = "palette_from_image-module--colors_from_image_wrapper--7a962";
export var dropd_zone_and_palette_wrapper = "palette_from_image-module--dropd_zone_and_palette_wrapper--cd447";
export var dropzone_formats = "palette_from_image-module--dropzone_formats--81c6d";
export var dropzone_hint = "palette_from_image-module--dropzone_hint--bb989";
export var dropzone_icon = "palette_from_image-module--dropzone_icon--4083c";
export var dropzone_text = "palette_from_image-module--dropzone_text--f693a";
export var dropzone_wrapper = "palette_from_image-module--dropzone_wrapper--9c931";
export var empty_state = "palette_from_image-module--empty_state--f43bd";
export var extracted_colors = "palette_from_image-module--extracted_colors--f62c5";
export var format_badge = "palette_from_image-module--format_badge--40536";
export var image_palette_wrapper = "palette_from_image-module--image_palette_wrapper--7e9bb";
export var image_wrapper = "palette_from_image-module--image_wrapper--8fabb";
export var palette_actions = "palette_from_image-module--palette_actions--0f5f6";
export var palette_from_image_wrapper = "palette_from_image-module--palette_from_image_wrapper--a05d0";
export var palette_image_container = "palette_from_image-module--palette_image_container--ec9cb";
export var subtitle = "palette_from_image-module--subtitle--07732";
export var toast = "palette_from_image-module--toast--8ffb9";
export var toastIn = "palette_from_image-module--toastIn--a615a";